import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, actions } from 'react-redux-form';
import { Row, Col, FormGroup } from 'react-bootstrap';
import RequiredInput from '../../../common/form/elements/required-input';
import RequiredAutoloadDate from './required-autoload-date';
import ArrowButton from '../../../common/button-arrow';
import { savePpcSettings } from '../../../../actions/ppc';
import AutoLoadDate from './autoload-date';

class PccSettingsForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      counter: 0
    }
  }

  onDeleteAutoLoadDate = (index) => {
    this.props.dispatch(actions.remove('deep.admin_ppc.settings.autoload_dates', index));
  };

  onSubmit = (payLoad) => {
    this.props.dispatch(actions.submitFields('deep.admin_ppc.settings', savePpcSettings(payLoad)));
  };

  addAutoLoadDate = () => {
    this.props.dispatch(actions.push('deep.admin_ppc.settings.autoload_dates', ''));
  };

  render() {
    return (
      <Form model="deep.admin_ppc.settings" onSubmit={this.onSubmit}>
        <Row>
          <Col lg={12}>
            <RequiredInput label="Points per €"
                           placeholder="e.g. 100"
                           model=".points_per_euro"
                           controlId="ppe"/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <RequiredInput label="Load fee %"
                           placeholder="e.g. 10"
                           model=".load_fee_percent"
                           controlId="loadFee"/>
          </Col>
        </Row>

        <RequiredAutoloadDate />
        {
          this.props.autoLoadDates.map((date, index) => {
            return <AutoLoadDate key={index}
                                 index={index}
                                 onDelete={this.onDeleteAutoLoadDate}/>
          })
        }

        <Row>
          <Col lg={12}>
            <FormGroup>
              <ArrowButton submit={false}
                           arrow={false}
                           onClick={this.addAutoLoadDate}
                           color="grey">Add date</ArrowButton>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <RequiredInput label="KYC limit €"
                           placeholder="e.g. 2000"
                           model=".kyc_limit_euro"
                           controlId="kycLimit"/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <RequiredInput label="PPC management URL"
                           placeholder="http://example.com"
                           model=".ppc_management_url"
                           controlId="ppcMgmtUrl"
                           inputType="url"/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <ArrowButton color="grey"
                         className="pull-right"
                         disabled={!this.props.formValid}>Save</ArrowButton>
          </Col>
        </Row>
      </Form>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    formValid: state.deep.forms.admin_ppc.settings.$form.valid,
    autoLoadDates: state.deep.admin_ppc.settings.autoload_dates || []
  };
};

export default connect(mapStateToProps)(PccSettingsForm);



// WEBPACK FOOTER //
// ./src/components/admin/ppc/settings/ppc-settings-form.jsx